import { Box } from '@material-ui/core';
import React, { useState } from 'react';
import { SideBarIncompleteReports } from './incomplete-reports/SideBarIncompleteReports';
import { SideBarNewTasks } from './new-tasks/SideBarNewTasks';
import { SideBarAvailabilityAlert } from './availability-alert/SideBarAvailabilityAlert';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';

export const MyElementsSmallScreenAlerts = () => {
  const { isMobile } = useCampfireTheme();
  const [showAll, setShowAll] = useState(false);

  // On mobile, prioritize alerts: Incomplete Reports > New Tasks > Availability
  // Show only the most important alert by default, with option to expand
  if (isMobile && !showAll) {
    return (
      <Box>
        {/* Always show incomplete reports first (highest priority) */}
        <SideBarIncompleteReports />

        {/* Show expand button if there are other alerts to show */}
        <Box mt={0.5} textAlign='center' onClick={() => setShowAll(true)} style={{ cursor: 'pointer' }}>
          <Box
            component='span'
            style={{
              fontSize: '12px',
              color: '#666',
              textDecoration: 'underline',
            }}
          >
            View all alerts
          </Box>
        </Box>
      </Box>
    );
  }

  // Desktop or mobile with showAll = true
  return (
    <Box>
      <SideBarIncompleteReports />
      <SideBarNewTasks />
      <SideBarAvailabilityAlert />

      {/* Show collapse button on mobile when showing all */}
      {isMobile && showAll && (
        <Box mt={0.5} textAlign='center' onClick={() => setShowAll(false)} style={{ cursor: 'pointer' }}>
          <Box
            component='span'
            style={{
              fontSize: '12px',
              color: '#666',
              textDecoration: 'underline',
            }}
          >
            Show less
          </Box>
        </Box>
      )}
    </Box>
  );
};
